// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-rating {
  max-width: 100%;
  display: inline-flex;
  white-space: nowrap;
}
:where(.vuetify-styles) .v-rating--readonly {
  pointer-events: none;
}

:where(.vuetify-styles) .v-rating__wrapper {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
}
:where(.vuetify-styles) .v-rating__wrapper--bottom {
  flex-direction: column-reverse;
}

:where(.vuetify-styles) .v-rating__item {
  display: inline-flex;
  position: relative;
}
:where(.vuetify-styles) .v-rating__item label {
  cursor: pointer;
}
:where(.vuetify-styles) .v-rating__item .v-btn--variant-plain {
  opacity: 1;
}
:where(.vuetify-styles) .v-rating__item .v-btn {
  transition-property: transform;
}
:where(.vuetify-styles) .v-rating__item .v-btn .v-icon {
  transition: inherit;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-rating--hover .v-rating__item:hover:not(.v-rating__item--focused) .v-btn {
  transform: scale(1.25);
}
:where(.vuetify-styles) .v-rating__item--half {
  overflow: hidden;
  position: absolute;
  clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%);
  z-index: 1;
}
:where(.vuetify-styles) .v-rating__item--half .v-btn__overlay, :where(.vuetify-styles) .v-rating__item--half:hover .v-btn__overlay {
  opacity: 0;
}

:where(.vuetify-styles) .v-rating__hidden {
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VRating/VRating.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,sDAAsD;AACxD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;AACV","sourcesContent":[".v-rating {\n  max-width: 100%;\n  display: inline-flex;\n  white-space: nowrap;\n}\n.v-rating--readonly {\n  pointer-events: none;\n}\n\n.v-rating__wrapper {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n}\n.v-rating__wrapper--bottom {\n  flex-direction: column-reverse;\n}\n\n.v-rating__item {\n  display: inline-flex;\n  position: relative;\n}\n.v-rating__item label {\n  cursor: pointer;\n}\n.v-rating__item .v-btn--variant-plain {\n  opacity: 1;\n}\n.v-rating__item .v-btn {\n  transition-property: transform;\n}\n.v-rating__item .v-btn .v-icon {\n  transition: inherit;\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n.v-rating--hover .v-rating__item:hover:not(.v-rating__item--focused) .v-btn {\n  transform: scale(1.25);\n}\n.v-rating__item--half {\n  overflow: hidden;\n  position: absolute;\n  clip-path: polygon(0 0, 50% 0, 50% 100%, 0 100%);\n  z-index: 1;\n}\n.v-rating__item--half .v-btn__overlay, .v-rating__item--half:hover .v-btn__overlay {\n  opacity: 0;\n}\n\n.v-rating__hidden {\n  height: 0;\n  opacity: 0;\n  position: absolute;\n  width: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
